import BaseComponent from '../abstracts/BaseComponent';
import zipCodeCountryRegExp from '../constants/zipCodeCountryRegExp';

const debug = false;

export default class ZipCodeComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.COUNTRY_SELECTOR_EVENTS.change]: this.setRegExp
    };
  }

  constructor(element) {
    super(element);

    // PDB-703 PDB-704 PDB-730
    !this.$el.hasAttribute('pattern') && this.setRegExp({ countryCode: document.documentElement.dataset.country });
  }

  setRegExp({ countryCode }) {
    const pattern = zipCodeCountryRegExp[countryCode];
    debug && console.log('[ZipCodeComponent.setRegExp] countryCode ' + countryCode + ' pattern ' + pattern);
    this.$el.setAttribute('pattern', pattern);
  }
}
